import React from "react";
import "./TextWithIcon.css";

interface TextWithIconProps {
  bold?: boolean;
  url?: string;
  label: string;
  spaceLeft?: boolean;
  inlineInfo?: boolean;
  icon?: string;
}

const TextWithIcon: React.FC<TextWithIconProps> = (props) => {
  const { bold, url, label, spaceLeft, inlineInfo } = props;
  let icon: string | undefined = undefined;
  if (props.icon) {
    try {
      icon = require(`../../../assets/icons/${props.icon}`);
    } catch (e) {
      console.log(e);
    }
  }
  let classes = "text-with-icon mb-1";
  if (bold) {
    classes = classes + " fw-bold";
  }

  if (inlineInfo) {
    classes = classes + " inline-info";
  }
  return (
    <div className={classes}>
      {icon && <img src={icon} alt={props.icon} className="mr-2 icon-image" />}
      {spaceLeft && <div className="mr-2 space-left" />}
      {url ? <a href={url}>{label}</a> : label}
    </div>
  );
};

export default TextWithIcon;
